<template>

    <b-container class="tos-body">
        <b-row class="justify-content-center">
            <b-col sx="12" sm="12" md="12" lg="8" xl="8">
                <h3>1. What I won't draw</h3>            
                <ol type="a">
                    <li>Any fetishes or potential interpretations of fetishes.</li>
                    <li>NSFW content, such as gore, intercourse, or uncensored nudity. </li>
                    <li>Anything with malicious intent such as callouts or hate speech.</li>
                    <li>Ideologically sensative material.</li>
                    <li>Extreme violence in a serious context.</li>
                    <li>Romantic situations based on real couples I don't know personally.</li>
                    <li>Fanart or art of copyrighted characters.</li>
                </ol>
            </b-col>
        </b-row>

        <b-row class="justify-content-center">
            <b-col sx="12" sm="12" md="12" lg="8" xl="8">
                <h3>2. What I can draw</h3>
                <ol type="a">
                    <li>Maws, paws, micro, macro, or underwear are okay as long as it's not sexually implicit.</li>
                    <li>Mild sexual themes, such as sexy poses, butts, bedroom eyes, etc.</li>
                    <li>Mild blood and injuries, such as nose bleeds, cuts, bruises, etc.</li>
                    <li>Alchohol and mild drug use.</li>
                </ol>
            </b-col>
        </b-row>

        <b-row class="justify-content-center">
            <b-col sx="12" sm="12" md="12" lg="8" xl="8">
                <h3>3. My style preferences</h3>
                <ol type="a">
                    <li>When drawing anthropomorphic animal characters, I prefer their physique to be more animal than human.</li>
                    <li>I prefer not to draw female anthros with human breasts.</li>
                    <li>I prefer to draw animal characters without clothes, however I can still draw clothes if requested.</li>
                </ol>
            </b-col>
        </b-row>

        <b-row class="justify-content-center">
            <b-col sx="12" sm="12" md="12" lg="8" xl="8">
                <h3>4. Commission rules</h3>
                <ol type="a">
                    <li>A SFW, up-to-date character reference sheet is required. Existing artwork of the character may also work.</li>
                    <li>If you don't have a character reference, I reccomend either coloring a blank template yourself which you 
                        can find online, or commission someone (or myself if available) a lineart ref, which you can color yourself as well.</li>
                    <li>When commissioning me, you also agree with my style choice, meaning the commission will not be streamed and 
                        work in progress shots will not be offered by default.</li>
                    <li>Free WIPs are offered for reference sheets and commissions over $80. For any other commission, I can offer 
                        WIP's at $3 per WIP shot. This is to avoid unpaid work time that can accumulate as a result of drawing revisions.</li>
                    <li>Deadlines might be okay, but because I can't draw full time, fulfillment of such cannot be promised.</li>
                    <li>Payment must be submitted by the time the base sketch is finished.</li>
                    <li>Asking me to work faster, harassing me, or generally being rude is not acceptable and may result in 
                        termination and refund of the commission.</li>
                    <li>Refunds, if needed, are based on the amount of work done.</li>
                    <li>I may refuse a commission if I don’t agree with the characters’ design.</li>
                    <li>Please credit me when artwork is being re-posted.</li>
                </ol>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
export default {
    name: 'comm_tos',
}
</script>

<style scoped>
    .tos-body {
        margin-top: 25px;
        margin-bottom: 25px;
        width: 100% !important;
    }
    .tos-body ol, h3 {
        text-align: left;
        width: 100% !important;
        display: inline-block;
    }
</style>
